var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "check.b2090efa.png","uri@2x": __webpack_public_path__ + "check.24112572.png","uri@3x": __webpack_public_path__ + "check.87952f8e.png",
    width: 48,
    height: 39
});